module.exports = __webpack_public_path__ + "static/img/hdzqt.93533a7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/hdzqt.png
// module id = AnDg
// module chunks = 1